import { render, staticRenderFns } from "./signContract.vue?vue&type=template&id=50154868&scoped=true"
import script from "./signContract.vue?vue&type=script&setup=true&lang=js"
export * from "./signContract.vue?vue&type=script&setup=true&lang=js"
import style0 from "./signContract.vue?vue&type=style&index=0&id=50154868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50154868",
  null
  
)

export default component.exports